/**
 * LBX - AddToWishList
 *
 * This script handles adding products to the product wish list,
 * allowing users to track product availability or manage their preferences.
 *
 */

import { connect } from 'react-redux';
import getStore from 'Util/Store';
import { isSignedIn } from 'Util/Auth';
import { showNotification } from 'Store/Notification/Notification.action';

const WishlistDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Wishlist/Wishlist.dispatcher'
);

const mapDispatchToProps = (dispatch) => ({
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    addItemToWishlist: (options) => WishlistDispatcher.then(
        ({ default: dispatcher }) => dispatcher.addItemToWishlist(dispatch, options)
    )
});

const _addToProductWishList = async (sku) => {
    const store = getStore();
    const state = store.getState();
    const { showNotification, addItemToWishlist } = mapDispatchToProps(store.dispatch);
    const { lbx_add_to_wishlist_enabled } = state.ConfigReducer;

    try {
        if (String(lbx_add_to_wishlist_enabled) !== '1') {
            throw new Error('Function is disabled');
        }

        if (!isSignedIn()) {
            showNotification('success', __('Pleas login in to add products to your wishlist.'));
        }

        if (!(typeof sku === 'string' || typeof sku === 'number')) {
            throw new Error('SKU must be a string or number');
        }

        return addItemToWishlist({ items: [{ sku }] });
    } catch (error) {
        console.error(`%c${error}`, 'color: white; background-color: red; border-radius: 1rem; padding: 0.15rem;');

        return Promise.reject(new Error(error));
    }
}

window.AddToProductWishList = (sku) => _addToProductWishList(sku);

connect(null, mapDispatchToProps)(_addToProductWishList);
